import { connect } from 'react-redux'
import Rollover from './rollover'
import { openSelectedUrl } from '../../../store/details/slice'
import { RootState } from '../../../store'
import { updateSelectedLocation } from '../../../store/search/actions'

const mapStateToProps = (state: RootState) => {
  return {
    byIds: state.details.byIds,
    clientX: state.details.clientX,
    clientY: state.details.clientY,
    selectedDetail: state.details.selectedDetail,
  }
}

const ConnectedRollover = connect(mapStateToProps, {
  openSelectedUrl,
  updateSelectedLocation,
})(Rollover)

export default ConnectedRollover
